import { Grid, makeStyles } from '@material-ui/core'
import resolveReasonIcon from 'components/common/icons/notifyPractice/resolveReasonIcon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DazzedHeading12 from './text/DazzedHeading12'

const useStyles = makeStyles(theme => ({
  icon: {
    padding: '0 5px',
    minWidth: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  label: {
    overflow: ({ withElipsis }) => (withElipsis ? 'hidden' : undefined),
    textOverflow: ({ withElipsis }) => (withElipsis ? 'ellipsis' : undefined),
    whiteSpace: ({ withElipsis }) => (withElipsis ? 'nowrap' : undefined)
  }
}))

const NeedsAttentionReason = ({ reason, shortened = false, withElipsis = true, color = '#001335' }) => {
  const classes = useStyles({ withElipsis })
  const { t } = useTranslation()

  return reason ? (
    <Grid container alignItems="center" justifyContent="flex-start" wrap="nowrap">
      <Grid item className={classes.icon}>
        {React.createElement(resolveReasonIcon(reason), { color })}
      </Grid>
      <DazzedHeading12 className={classes.label} style={{ color }} xs={12} semibold>
        {shortened
          ? t(`dialogs.notifyPractice.reasons.${reason}Shortened`, {
              defaultValue: t(`dialogs.notifyPractice.reasons.${reason}`)
            })
          : t(`dialogs.notifyPractice.reasons.${reason}`)}
      </DazzedHeading12>
    </Grid>
  ) : (
    <></>
  )
}

export default NeedsAttentionReason
